import React, { useEffect, useState } from "react";
import { getBranchOwner, api, put, consts } from "@config";
import { Modal, Button } from "react-bootstrap";
import SweetAlert from "react-bootstrap-sweetalert";
import Taker from './taker';
import { StyledCard, StyledCardHeader, SectionTitle, PillContainer, LayoutGrid } from './styles';

const formatCpfCnpj = (value) => {
  if (!value) return "";
  const cleaned = String(value).replace(/\D/g, "");
  if (cleaned.length === 11) return cleaned.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
  if (cleaned.length === 14) return cleaned.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5");
  return value;
};

const formatCep = (value) => {
  if (!value) return "";
  const cleaned = String(value).replace(/\D/g, "");
  if (cleaned.length === 8) return cleaned.replace(/(\d{5})(\d{3})/, "$1-$2");
  return value;
};

export default function Provider() {
  const [branch, setBranch] = useState({
    address: {},
    branch: { company: {} },
    individual: {},
  });
  const [insertMunicipalRegistry, setInsertMunicipalRegistry] = useState(false);
  const [updateMunicipalRegistryAlert, setUpdateMunicipalRegistryAlert] = useState(false);

  useEffect(() => {
    const currentBranch = getBranchOwner();
    setBranch(currentBranch);

    if (currentBranch.company && !currentBranch.company.municipal_registry) {
      setInsertMunicipalRegistry(true);
    }

    if (window.location.search === "?updated-municipal-registry") {
      setUpdateMunicipalRegistryAlert(true);
    }
  }, []);

  let providerIM = "Não tem";
  let providerCPFCNPF = { type: "", number: "" };
  
  if (branch.company) {
    providerIM = branch.company.municipal_registry || "Não tem";
    providerCPFCNPF = { type: "CNPJ", number: branch.company.cnpj };
  } else {
    providerCPFCNPF = { type: "CPF", number: (branch.individual && branch.individual.cpf) || "" };
  }

  return (
    <React.Fragment>
      <LayoutGrid>
        <StyledCard>
          <StyledCardHeader>
            <div>
              <SectionTitle><i className="fas fa-building"></i> Dados do Prestador</SectionTitle>
              <span className="text-secondary" style={{fontSize: '0.9rem'}}>Informações do emissor da nota</span>
            </div>
          </StyledCardHeader>
          <h4 style={{fontWeight: 700, marginBottom: '20px'}}>{branch.name}</h4>
          
          <div style={{ display: 'flex', gap: '16px', marginBottom: '20px', flexWrap: 'wrap' }}>
            <PillContainer style={{ flex: '1 1 180px' }}>
              <span className="label">{providerCPFCNPF.type}</span>
              <span className="value">{formatCpfCnpj(providerCPFCNPF.number)}</span>
            </PillContainer>
            <PillContainer style={{ flex: '1 1 180px' }}>
              <span className="label">Inscrição Municipal</span>
              <span className="value">{providerIM}</span>
            </PillContainer>
          </div>

          <div style={{ marginTop: '16px', background: '#F9FAFB', padding: '16px', borderRadius: '8px', border: '1px solid #EAECF0', minHeight: '96px' }}>
             <span style={{ fontSize: '0.8rem', fontWeight: 600, color: '#667085', textTransform: 'uppercase' }}>Endereço Completo</span>
             <p style={{ margin: 0, marginTop: '8px', fontWeight: 500 }}>
                {formatCep((branch.address && branch.address.postal_code) || "")}, {(branch.address && branch.address.street) || ""} {(branch.address && branch.address.street_number) || ""}, {(branch.address && branch.address.district) || ""}, {(branch.address && branch.address.city) || ""}/{(branch.address && branch.address.state) || ""}
             </p>
          </div>
        </StyledCard>

        <Taker />
      </LayoutGrid>

      <Modal show={insertMunicipalRegistry} onHide={() => window.location.href = '/'}>
        <Modal.Header closeButton>
          <h2 className="col-12 pb-0 mb-0"><strong>Inscrição Municipal</strong> não encontrada!</h2>
        </Modal.Header>
        <Modal.Body>
          <p className="lead pb-1">É necessário informar a sua inscrição municipal para a emissão.</p>
          <Button onClick={() => window.location.href = '/nfse/settings'}>Ir para as configurações</Button>
        </Modal.Body>
      </Modal>

      <SweetAlert
        show={updateMunicipalRegistryAlert}
        success
        confirmBtnText="Emitir NFS-e"
        onConfirm={() => window.location.href = '/nfse'}
        title="Inscrição Municipal Atualizada" />
    </React.Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/views/Fiscal/NFSe/emit/components/provider.jsx